module.exports = __webpack_public_path__ + "static/media/clock.742f6f31.svg";